import { handle400Statuses, sendApiRequest } from './api';
import { logNetRequest } from '@utils/usefulFuncs';

const BASE_URL = 'v1/genai/box_doc_ingestion_configs';

export async function listBoxDocIngestionConfigs() {
  const { status, data, error } = await sendApiRequest('get', BASE_URL);
  logNetRequest(status, data, error);
  handle400Statuses(status);

  if (status === 200 && data?.box_doc_ingestion_configs) {
    return {
      boxDocIngestionConfigs: data.box_doc_ingestion_configs,
      error: null,
    };
  }

  return {
    boxDocIngestionConfigs: [],
    error: data?.error || error || 'Failed to load Box ingestion configs.',
  };
}

export async function updateBoxDocIngestionConfigValidTags(boxDocIngestionConfigId, validTags) {
  const url = `${BASE_URL}/${boxDocIngestionConfigId}`;
  const payload = {
    valid_tags: validTags,
  };
  const { status, data, error } = await sendApiRequest('patch', url, payload);
  logNetRequest(status, data, error);
  handle400Statuses(status);

  if (status === 200) {
    return {
      boxDocIngestionConfig: data,
      error: null,
    };
  }

  return {
    boxDocIngestionConfig: null,
    error: data?.error || error || 'Failed to update Box ingestion config.',
  };
}

export async function syncBoxDocIngestionConfig(boxDocIngestionConfigId) {
  const url = `${BASE_URL}/${boxDocIngestionConfigId}/sync`;
  const { status, data, error } = await sendApiRequest('post', url, {});
  logNetRequest(status, data, error);
  handle400Statuses(status);

  if (status === 200) {
    const merged =
      data?.box_doc_ingestion_config != null
        ? data.box_doc_ingestion_config
        : data != null && typeof data === 'object' && data.id != null
        ? data
        : null;
    return {
      boxDocIngestionConfig: merged,
      error: null,
    };
  }

  return {
    boxDocIngestionConfig: null,
    error: data?.error || error || 'Failed to sync Box ingestion config.',
  };
}
